import { render } from "./StatusSection.vue?vue&type=template&id=97b713a6"
import script from "./StatusSection.vue?vue&type=script&lang=js"
export * from "./StatusSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__